module.exports = __webpack_public_path__ + "media/dashboard/assets/images/sidebar/whatsapp-8e1c08eb328db3dcbc617cbb3d7ed3b9.svg";